import React from 'react';
import { connect } from "react-redux";
import { ConversationalForm } from 'conversational-form';
import { bindActionCreators } from "redux";
import _ from 'lodash';
import { changeUserAttribute, changeAttribute } from "../../actions/auth";
import './Survey.scss';

class Survey extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      conversationFinished: false
    };
    this.formFields = [
      {
        'tag': 'cf-robot-message',
        'type': 'text',
        'name': 'greeting',
        'cf-questions': 'Hi! Welcome to Content Camel 👋'
      },
      {
        'tag': 'cf-robot-message',
        'type': 'text',
        'name': 'intro',
        'cf-questions': "Just a few questions, so we can get everything all set up for you!"
      },
      {
        "tag": "fieldset",
        "type": "Radio buttons",
        "cf-input-placeholder": "Choose one of the above",
        "cf-questions": "How do you plan on using Content Camel?",
        "name": "teamType",
        "children":[
          {
            "tag": "input",
            "type": "radio",
            "name": "teamTypeUsage",
            "cf-label": "As a solo user",
            "value": "solo"
          },
          {
            "tag": "input",
            "type": "radio",
            "name": "teamTypeUsage",
            "cf-label": "As a small team",
            "value": "smallTeam",
            "checked": "checked"
          },
          {
            "tag": "input",
            "type": "radio",
            "name": "teamTypeUsage",
            "cf-label": "As a growing organization",
            "value": "growingOrg"
          }
        ]
      },          
      {
        "tag": "fieldset",
        "type": "Checkboxes",
        "cf-input-placeholder": "Choose as many as makes sense",
        "cf-questions": "Great. So, where's your content today?",
        "name": "contentLocation",
        "children":[
          {
            "tag": "input",
            "type": "checkbox",
            "name": "contentLocationOption",
            "value": "googleDrive",
            "cf-label": "Google Drive",
          },
          {
            "tag": "input",
            "type": "checkbox",
            "name": "contentLocationOption",
            "value": "dropbox",
            "cf-label": "Dropbox"
          },
          {
            "tag": "input",
            "type": "checkbox",
            "name": "contentLocationOption",
            "value": "sharepoint",
            "cf-label": "Sharepoint/OneDrive"
          },
          {
            "tag": "input",
            "type": "checkbox",
            "name": "contentLocationOption",
            "value": "box",
            "cf-label": "Box"
          },
          {
            "tag": "input",
            "type": "checkbox",
            "name": "contentLocationOption",
            "value": "youtube",
            "cf-label": "Youtube"
          },
          {
            "tag": "input",
            "type": "checkbox",
            "name": "contentLocationOption",
            "value": "vimeoOrWistia",
            "cf-label": "Vimeo/Wistia"
          },
          {
            "tag": "input",
            "type": "checkbox",
            "name": "contentLocationOption",
            "value": "webAndBlog",
            "cf-label": "Web/Blog"
          },
          {
            "tag": "input",
            "type": "checkbox",
            "name": "contentLocationOption",
            "value": "other",
            "cf-label": "Other"
          }
        ]
      },
    ];
    
    this.submitCallback = this.submitCallback.bind(this);
  }
  
  navigateToNextStep() {
    if (this.state.conversationFinished) {
      this.props.history.push('/onboarding/infographics');
    }
  }

  componentDidMount() {
    const customState = _.get(this.props, "cognitoUser.attributes['custom:state']", null);

    // if (customState === 'onboarding-01') {
    //   this.props.history.push('/onboarding/survey');
    // } else if (customState === 'onboarding-03') {
    //   this.props.history.push('/onboarding/checklist');
    // } else if (customState === 'onboarding') {
    //   this.props.history.push('/onboarding');
    // }

    if (customState && (!customState.includes('onboarding') && customState !== 'invited')) {
      this.props.history.push('/dashboard')
    }

    this.cf = ConversationalForm.startTheConversation({
      options: {
        submitCallback: this.submitCallback,
        preventAutoFocus: true,      },
      tags: this.formFields
    });
    this.elem.appendChild(this.cf.el);
  }
  
  submitCallback() {
    const formDataSerialized = this.cf.getFormData(true);
    
    const onboardingInfo = {
      teamType: formDataSerialized.teamType,
      contentLocation: formDataSerialized.contentLocation
    };
    
    this.cf.addRobotChatResponse("Thanks! Now, let's check out features and best practices 🚀");
    this.props.changeUserAttribute({ name: 'state', value: 'onboarding-02' });
    this.props.changeAttribute([
      { name: 'onboardingInfo', value: onboardingInfo }
    ]);
    
    setTimeout(() => {
      this.setState({conversationFinished: true});
      this.navigateToNextStep();
    }, 5000);
  }
  
  render() {
    return (
      <div className="onboarding-survey-container">
        <div className="conversational-container"
          ref={ref => this.elem = ref}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.tenant,
  cognitoUser: state.auth.cognitoUser
});

const mapDispatchToProps = dispatch => 
  bindActionCreators({
    changeUserAttribute,
    changeAttribute
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Survey);
